export const keys = {
  photoCapture: "photoCapture",
  logout: "logout",

  photoUtilityDescription: "photoUtilityDescription",

  imageManagement: "imageManagement",

  imageDragged: "imageDragged",
  imagesSelected: "imagesSelected",
  media: "media",
  manageProductImages: "manageProductImages",
  selectAllImages: "selectAllImages",
  deleteImages: "deleteImages",
  sentImages: "sentImages",
  sentImagesConfirmation: "sentImagesConfirmation",
  deleteImagesConfirmation: "deleteImagesConfirmation",
  retailerImagePosition: "retailerImagePosition",

  noProductFoundUpload: "noProductFoundUpload",
  noProductFoundScanned: "noProductFoundScanned",
  stockCodeWarning: "stockCodeWarning",
  searchProducts: "searchProducts",

  takePhoto: "takePhoto",
  scanAgain: "scanAgain",
  newProduct: "newProduct",
  finished: "finished",

  imagesSentSuccessfully: "imagesSentSuccessfully",
};
